// Обобщението на „Гости" върху ПОКАЗАНИТЕ редове — кутийките следват
// търсачката и филтрите, както таблицата и Excel.
//
// „Ненадеждни" са гостите с поне една неизпълнена резервация — това е
// въпросът, за който справката съществува (кого да потвърдиш по телефона).

import { parseDecimal } from "../../../../components/dataTable";
import type { ReservationGuestRow } from "../../../../api/reportsReservations";

export type GuestsSummaryView = {
  guestsCount: number;
  reservations: number;
  returningGuests: number;
  guestsWithNoShow: number;
  revenue: number;
};

export const summarizeGuestRows = (
  rows: readonly ReservationGuestRow[],
): GuestsSummaryView => {
  let reservations = 0;
  let returningGuests = 0;
  let guestsWithNoShow = 0;
  let revenue = 0;
  for (const row of rows) {
    reservations += row.reservations;
    if (row.reservations > 1) returningGuests += 1;
    if (row.expired > 0) guestsWithNoShow += 1;
    revenue += parseDecimal(row.revenue);
  }
  return {
    guestsCount: rows.length,
    reservations,
    returningGuests,
    guestsWithNoShow,
    revenue,
  };
};
